export const tripTableWidths = {
  linha: '22%',
  sentido: '12%',
  cliente: '20%',
  veiculo: '12%',
  unidade: '12%',
  codigo: '12%',
  pontosatendidos: '6%',
  progresso: '4%',
  inicioPrevisto: '8%',
  inicioReal: '8%',
  finalPrevisto: '8%',
  finalReal: '8%',
  status: '10%'
};

export const formatProgressValue = (
  value,
  progress,
  forExcel = false
) => {

  const separator = forExcel
    ? ' - '
    : '\n';

  const progressLabel =
    progress != null
      ? `${progress}%`
      : '-';

  return `${value}${separator}${progressLabel}`;
};